import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum PendingReasonsEnum {
    None = 0 as number,
    "After-hours call request" = 1 as number,
    "Attending physician certification" = 2 as number,
    "Awaiting relocation" = 3 as number,
    "Cannot contact decision maker" = 4 as number,
    Hospitalized = 5 as number,
    "Long term - live discharge" = 6 as number,
    "Long term - awaiting eligibility" = 7 as number,
    "Medical director certification" = 8 as number,
    "Need documentation" = 9 as number,
    "Patient resides in non-contracted facility" = 10 as number,
    "Patient/family - deciding on care options" = 11 as number,
    "Patient/family - interviewing hospices" = 12 as number,
    "Patient/family - refusing services" = 13 as number,
    "Priority scheduling" = 14 as number,
    "Scheduled visit" = 15 as number,
    "Skilled nursing" = 16 as number,
    "Waiting on call back" = 17 as number,
    Other = 18 as number
}

class PendingReasonsClass extends EnumWithDescription<PendingReasonsEnum> {
    public readonly enum = PendingReasonsEnum;
    public readonly enumName: string = "PendingReasonsEnum";

    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<PendingReasonsEnum>> = new Map([
        [
            "None",
            {
                value: PendingReasonsEnum.None,
                name: "None"
            }
        ],
        [
            "After-hours call request",
            {
                value: PendingReasonsEnum["After-hours call request"],
                name: "After-hours call request"
            }
        ],
        [
            "Attending physician certification",
            {
                value: PendingReasonsEnum["Attending physician certification"],
                name: "Attending physician certification"
            }
        ],
        [
            "Awaiting relocation",
            {
                value: PendingReasonsEnum["Awaiting relocation"],
                name: "Awaiting relocation"
            }
        ],
        [
            "Cannot contact decision maker",

            {
                name: "Cannot contact decision maker",
                value: PendingReasonsEnum["Cannot contact decision maker"]
            }
        ],
        [
            "Hospitalized",
            {
                name: "Hospitalized",
                value: PendingReasonsEnum.Hospitalized
            }
        ],
        [
            "Long term - live discharge",
            {
                name: "Long term - live discharge",
                value: PendingReasonsEnum["Long term - live discharge"]
            }
        ],
        [
            "Long term - awaiting eligibility",
            {
                name: "Long term - awaiting eligibility",
                value: PendingReasonsEnum["Long term - awaiting eligibility"]
            }
        ],
        [
            "Medical director certification",
            {
                name: "Medical director certification",
                value: PendingReasonsEnum["Medical director certification"]
            }
        ],
        [
            "Need documentation",
            {
                name: "Need documentation",
                value: PendingReasonsEnum["Need documentation"]
            }
        ],
        [
            "Patient resides in non-contracted facility",
            {
                name: "Patient resides in non-contracted facility",
                value: PendingReasonsEnum["Patient resides in non-contracted facility"]
            }
        ],
        [
            "Patient/family - deciding on care options",
            {
                name: "Patient/family - deciding on care options",
                value: PendingReasonsEnum["Patient/family - deciding on care options"]
            }
        ],
        [
            "Patient/family - interviewing hospices",
            {
                name: "Patient/family - interviewing hospices",
                value: PendingReasonsEnum["Patient/family - interviewing hospices"]
            }
        ],
        [
            "Patient/family - refusing services",
            {
                name: "Patient/family - refusing services",
                value: PendingReasonsEnum["Patient/family - refusing services"]
            }
        ],
        [
            "Priority scheduling",
            {
                name: "Priority scheduling",
                value: PendingReasonsEnum["Priority scheduling"]
            }
        ],
        [
            "Scheduled visit",
            {
                name: "Scheduled visit",
                value: PendingReasonsEnum["Scheduled visit"]
            }
        ],
        [
            "Skilled nursing",
            {
                name: " Skilled nursing",
                value: PendingReasonsEnum["Skilled nursing"]
            }
        ],
        [
            "Waiting on call back",
            {
                name: "Waiting on call back",
                value: PendingReasonsEnum["Waiting on call back"]
            }
        ],
        [
            "Other",
            {
                name: "Other",
                value: PendingReasonsEnum.Other
            }
        ]
    ]);
}

export const PendingReasons = new PendingReasonsClass();
